import { Route, Routes, Navigate } from 'react-router-dom';
import { PredictionsPage } from './pages';
import { PositionsPage } from './pages/PositionsPage';
import { PredictionMapperPage } from 'src/Modules/PredictionMapper';
import { PredictionsStatus } from 'src/Modules/Arbitrage/pages/PredictionsStatus';
import { PredictionsProviders } from './Providers';

export const PredictionsRouter = () => {
  return (
    <Routes>
      <Route
        path="opportunities"
        element={
          <PredictionsProviders>
            <PredictionsPage />
          </PredictionsProviders>
        }
      />
      <Route path="positions" element={<PositionsPage />} />
      <Route path="mapper" element={<PredictionMapperPage />} />
      <Route path="status" element={<PredictionsStatus />} />
      <Route path="*" element={<Navigate replace to="opportunities" />} />
    </Routes>
  );
};
